import { getDevelopmentFlag } from '@mentimeter/development-flags';
import type { BooleanEntitlement } from './types';

export function potentiallyOverrideBooleanEntitlement<
  E extends BooleanEntitlement,
>(booleanEntitlement: E): E {
  const booleanEntitlementsReasonOverride = getDevelopmentFlag(
    'boolean-entitlements-reason-override',
  );

  if (booleanEntitlementsReasonOverride) {
    return {
      ...booleanEntitlement,
      value: false,
      reason: booleanEntitlementsReasonOverride,
    };
  }

  return booleanEntitlement;
}
